import BaseModel from '../core/BaseModel'
export default class ViewProvinceModel extends BaseModel {
    constructor() {
        super({ 
                name: "view_province",
                tableName: 'view_province'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}